import type { PageLoader } from "./beanInfo";

/**
 * PageLoader that goes through the Puck Tech CORS proxy (see /proxy in the repo). Browsers block direct reads of
 * other sites' HTML, so the Worker fetches the page and returns it with CORS headers.
 *
 * The proxy URL comes from VITE_PROXY_URL at build time when set (e.g. to point a preview build at a test Worker);
 * otherwise the deployed production Worker is used. Set VITE_PROXY_URL to "off" to disable link import.
 */
export const DEFAULT_PROXY_URL = "https://pucktech-proxy.olwells661.workers.dev";

const configured = (import.meta.env["VITE_PROXY_URL"] as string | undefined)?.trim();
export const PROXY_URL: string = configured === "off" ? "" : configured || DEFAULT_PROXY_URL;

export function proxyConfigured(): boolean {
  return PROXY_URL !== "";
}

export function proxyPageLoader(proxyUrl: string = PROXY_URL, timeoutMs = 12_000): PageLoader {
  return async (url: string) => {
    if (!proxyUrl) return null;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const res = await fetch(`${proxyUrl}?url=${encodeURIComponent(url)}`, { signal: controller.signal });
      if (!res.ok) return null;
      return await res.text();
    } catch {
      return null;
    } finally {
      clearTimeout(timer);
    }
  };
}
